import { apiClient } from './client';
import { useAuthStore } from '../store/authStore';
import type { User } from '../types';

export interface LoginCredentials {
  username: string;
  password: string;
}

export interface RegisterData extends LoginCredentials {
  email: string;
}

export interface AuthResponse {
  token: string;
  user: User;
}

interface BackendTokenResponse {
  access_token: string;
  token_type: string;
}

export async function login(credentials: LoginCredentials): Promise<AuthResponse> {
  const { data } = await apiClient.post<BackendTokenResponse>('/auth/login', credentials);
  const token = data.access_token;
  // Temporarily set token so getCurrentUser can auth
  useAuthStore.setState({ token });
  const user = await getCurrentUser();
  return { token, user };
}

export async function register(data: RegisterData): Promise<AuthResponse> {
  const { data: response } = await apiClient.post<BackendTokenResponse>('/auth/register', data);
  const token = response.access_token;
  useAuthStore.setState({ token });
  const user = await getCurrentUser();
  return { token, user };
}

export async function getCurrentUser(): Promise<User> {
  const { data } = await apiClient.get<User>('/auth/me');
  return data;
}

export async function forgotPassword(identifier: string): Promise<{ message: string; email_sent: boolean }> {
  const { data } = await apiClient.post('/auth/forgot-password', { identifier });
  return data;
}

export async function resetPassword(token: string, newPassword: string): Promise<void> {
  await apiClient.post('/auth/reset-password', { token, new_password: newPassword });
}

export async function changePassword(currentPassword: string, newPassword: string): Promise<void> {
  await apiClient.post('/auth/change-password', {
    current_password: currentPassword,
    new_password: newPassword,
  });
}
